import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'localeNumber',
    standalone: false
})

export class LocaleNumberPipe implements PipeTransform {
  public locale = 'et-EE';
  // in storybook gives wrong value, use later :)
  // constructor(@Inject(LOCALE_ID) public locale: string) {}

  transform(value: string): any {
    const newValue = value.toString().includes(',') ? value.replace(/,/g, '.') : value;
    return parseFloat(newValue).toLocaleString(this.locale);
  }

}
